module.exports = __webpack_public_path__ + "e7b994a.mp4";